import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import {
  SplitBillQrCodeContainer,
  TitleContainer,
  Title,
  SubTitle,
  QrCodeContainer,
} from './index.view';
import QRCode from 'react-qr-code';
import CopyToClipBoard from 'components/CopyToClipBoard';
import { SESSION } from 'constants/enum/session';

interface ShareQrCodeProps {
  total?: number;
  type?: string;
}

const ShareQrCode = ({ total, type }: ShareQrCodeProps) => {
  const { t } = useTranslation();
  const splitToken = sessionStorage?.getItem(SESSION.HEAD_SPLIT_TOKEN) ?? '';
  const paymentUrl = process.env.NX_PAYMENT_FRONTEND_URL || 'http://localhost:3001';

  const url = useMemo(() => {
    return type === 'split.amount'
      ? `${paymentUrl}/${splitToken}/split-bill-equality`
      : `${paymentUrl}/${splitToken}/split-bill-by-item`;
  }, [splitToken, paymentUrl, type]);

  return (
    <>
      <TitleContainer>
        <Title>{t('splitBillWaitingShareQrCodeTitle')}</Title>
        <SubTitle>{t('splitBillWaitingShareQrCodeSubTitle', { total })}</SubTitle>
      </TitleContainer>

      <SplitBillQrCodeContainer>
        <QrCodeContainer>
          <QRCode value={url} size={275} />
        </QrCodeContainer>

        <CopyToClipBoard value={url} />
      </SplitBillQrCodeContainer>
    </>
  );
};

export default ShareQrCode;
